module.exports = __webpack_public_path__ + "img/pro_four_4.aa99d0b2.jpg";